import * as React from 'react';
import { Button } from 'react-admin';
import { Password } from '@mui/icons-material';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ResetPasswordModal from './ResetPasswordModal';

const useStyles = makeStyles({
  tooltip: {
    fontSize: '14px',
  },
});

const messages = {
  tooltip: {
    loginSocialTitle: 'Login vinculado a uma conta externa (ex: Google, Apple). O usuário deve redefinir a senha ou alterar o e-mail diretamente nas configurações do serviço utilizado.',
    loginLeadTitle: 'Usuário não cadastrado',
    emailChangedTitle: 'E-mail alterado, salve os dados do usuário antes de redefinir a senha.'
  },
  button: {
    resetPassword: 'Enviar redefinição de senha',
  }
}

const ResetPasswordButton = ({ userId, email, isLoginLead, isLoginSocial, emailEdited }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  if (isLoginSocial || isLoginLead || emailEdited)
    return (
      <Tooltip title={isLoginLead ? messages.tooltip.loginLeadTitle : emailEdited ? messages.tooltip.emailChangedTitle : messages.tooltip.loginSocialTitle}
        classes={{ tooltip: classes.tooltip }}
      >
        <span>
          <Button
            onClick={handleOpen}
            label={messages.button.resetPassword}
            variant="outlined"
            color="inherit"
            disabled
            sx={{ color: "#888", borderColor: "#ccc" }}
          >
            <Password />
          </Button>
        </span>
      </Tooltip>
    );

  return (
    <>
      <Button
        onClick={handleOpen}
        label={messages.button.resetPassword}
        variant="outlined"
      >
        <Password />
      </Button>
      <ResetPasswordModal open={open} onClose={handleClose} userId={userId} email={email} />
    </>
  );
};

export default ResetPasswordButton;
